import "./DryingAndBlowOff.module.css";
import Header from "@/reusable_sections/Header";
import Blowoff from "./sections/Blowoff";
import DryingOverview from "./sections/DryingOverview";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function DryingAndBlowOffPage() {
  return <div>
      <Header />
      <Blowoff />
      <DryingOverview />
      <CallToAction />
      <Footer />
    </div>;
}